export const branches = {
    branches: [
        {
            text: 'Automotor',
            origin: 'LEGACY_QUOTING',
            mode: 'CALL_NEW_QUOTE_AUTO',
            icon: 'assets/images/icon-rama-auto.svg',
            id: 'selector_rama_automotor',
            hideForFeatureToggle: 'cotizador-unificado'
        },
        {
            text: 'Automotor',
            origin: 'DYNAMO_BASE',
            tokenType: 'DYNAMO',
            mode: 'EMBEDDED',
            route: '/auto-unified',
            icon: 'assets/images/icon-rama-auto.svg',
            id: 'selector_rama_automotor-unified',
            showForFeatureToggle: 'cotizador-unificado',
            shouldShowPasSelector: true,
            shouldShowCategorySelector: true
        },
        {
            text: 'Flota',
            link: 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=AutomovilFlota',
            origin: 'LEGACY_BASE',
            tokenType: 'NUEVO_PORTAL_TOKEN',
            mode: 'EMBEDDED',
            route: 'legado',
            icon: 'assets/images/icon-rama-flota.svg',
            id: 'selector_rama_automotor_flota',
        },
        {
            text: 'Automotor Lite',
            origin: 'DYNAMO_BASE',
            tokenType: 'DYNAMO',
            mode: 'EMBEDDED',
            route: '/auto-lite',
            icon: 'assets/images/icon-rama-auto-lite.svg',
            id: 'selector_rama_automotor-lite',
            hideForFeatureToggle: 'cotizador-unificado',
            shouldShowPasSelector: true
        },
        {
          text: 'Automotor Lite off-core',
          origin: 'DYNAMO_BASE',
          tokenType: 'DYNAMO',
          mode: 'EMBEDDED',
          route: '/car-lite',
          icon: 'assets/images/icon-rama-auto-lite.svg',
          id: 'selector_rama_automotor-lite',
          showForFeatureToggle: 'cotizador-unificado',
          shouldShowPasSelector: true
        },
        {
          text: 'Automotor Lite',
          origin: 'DYNAMO_BASE',
          tokenType: 'DYNAMO',
          mode: 'EMBEDDED',
          route: '/auto-lite',
          icon: 'assets/images/icon-rama-auto-lite.svg',
          id: 'selector_rama_automotor-lite',
          showForFeatureToggle: 'cotizador-unificado',
          shouldShowPasSelector: true
        },
        {
            text: 'Hogar',
            link: 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=IntegralhogarDynamo',
            origin: 'LEGACY_BASE',
            tokenType: 'NUEVO_PORTAL_TOKEN',
            mode: 'EMBEDDED',
            route: 'legado',
            icon: 'assets/images/icon-rama-hogar.png',
            id: 'selector_rama_hogar'
        },
        {
            text: 'Integral de comercio',
            link: 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=IntegralComercioDynamo',
            origin: 'LEGACY_BASE',
            tokenType: 'NUEVO_PORTAL_TOKEN',
            mode: 'EMBEDDED',
            route: '/cotizador-integral-comercio/cotizacion',
            icon: 'assets/images/icon-rama-comercio.png',
            id: 'selector_rama_integral_comercio',
            shouldShowPasSelector: true
        },
        {
            text: 'Integral de consorcio',
            link: 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=IntegralConsorcio',
            origin: 'LEGACY_BASE',
            tokenType: 'NUEVO_PORTAL_TOKEN',
            mode: 'EMBEDDED',
            route: 'legado',
            icon: 'assets/images/icon-rama-consorcio.png',
            id: 'selector_rama_integral_consorcio'
        },
        {
            text: 'Accidentes personales',
            link: 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=AccidentesPersonales',
            origin: 'LEGACY_BASE',
            tokenType: 'NUEVO_PORTAL_TOKEN',
            mode: 'EMBEDDED',
            route: '/cotizador-accidentes-personales/cotizacion',
            icon: 'assets/images/icon-rama-accidentes-personales.png',
            id: 'selector_rama_accidentes_personales',
            shouldShowPasSelector: true
        },
        {
            text: 'Granizo',
            link: 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=Granizo',
            origin: 'LEGACY_BASE',
            tokenType: 'NUEVO_PORTAL_TOKEN',
            mode: 'EMBEDDED',
            route: 'legado',
            icon: 'assets/images/icon-rama-granizo.png',
            id: 'selector_rama_granizo'
        },
        {
            text: 'Incendio',
            link: 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=Incendio',
            origin: 'LEGACY_BASE',
            tokenType: 'NUEVO_PORTAL_TOKEN',
            mode: 'EMBEDDED',
            route: 'legado',
            icon: 'assets/images/icon-rama-incendio.png',
            id: 'selector_rama_incendio'
        },
        {
            text: 'Transporte',
            link: 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=Transporte',
            origin: 'LEGACY_BASE',
            tokenType: 'NUEVO_PORTAL_TOKEN',
            mode: 'EMBEDDED',
            route: 'legado',
            icon: 'assets/images/icon-rama-transporte.png',
            id: 'selector_rama_transporte'
        }
    ]
};
